import React from "react";
import { Button, TextArea } from "semantic-ui-react";
import { Utils } from "../../common/utils";
import EmailAddressSearch from "./EmailAddressSearch";
import { getCultureFromLcid } from "utilities/enumutils";

interface Props {
  onEmailsSelected: (emails: string, firstCulture: server.dto.Culture) => void
  initialEmails: string
  suggestedApiInstruction: server.dto.ListContactAddressBookToItemInstruction
}

const SelectMultipleAddressees = (props: Props) => {
  const [firstCulture, setFirstCulture] = React.useState<server.dto.Culture>(null);
  const [output, setOutput] = React.useState<string>(props.initialEmails);

  const onOutputBlur = () => {
    setOutput(Utils.processManualRecipientsString(output));
  };

  const onContactClick = (contact: server.dto.ContactAddressBookEntry, email: string) => {
    const result = Utils.processManualRecipientsString(output + " " + email);
    setOutput(result);

    if (firstCulture == null) {
      setFirstCulture(getCultureFromLcid(contact.culture));
    }
  };

  const onEmailTextChange = (value: string) => {
    setOutput(value);
    if (value.trim() === "") {
      setFirstCulture(null);
    }
  };

  return <EmailAddressSearch
    suggestedApiInstruction={props.suggestedApiInstruction}
    onContactClick={onContactClick}
  >
    <TextArea
      onBlur={onOutputBlur}
      className="margin-bottom"
      style={{ minHeight: 65 }}
      value={output}
      onChange={(_, { value }) => { onEmailTextChange(value.toString()); }}
    />

    <div className="flex margintop">
      <div className="grow1"></div>
      <Button primary onClick={() => { props.onEmailsSelected(output, firstCulture); }}>{RESX.Buttons.btnSelect}</Button>
    </div>
  </EmailAddressSearch>;
};

export default SelectMultipleAddressees;